import styled from "styled-components";
import {Row, Table} from "antd";

export const StyledTable = styled(Table)`
  .ant-table-body{
    .ant-table-cell{
      &.basic{
        vertical-align: baseline;
      }
    }
  }
`